import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/global.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div>
      <section className="section">
        <div className="container" style={{ textAlign: 'center', minHeight: '500px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <h1 style={{ fontSize: '4rem', color: 'var(--primary-color)', marginBottom: '1rem' }}>
            404
          </h1>
          <h2 style={{ marginBottom: '1rem' }}>Page Not Found</h2>
          <p style={{ marginBottom: '2rem', fontSize: '1.1rem' }}>
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/')}
            >
              🏠 Go to Home
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => navigate('/menu')}
            >
              📋 View Menu
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
